import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { teal, amber, yellow } from '@material-ui/core/colors';

import { UserController, ProductController, StripeController } from "controllers";

/**
 *
 * @param {*} lateBox

 */
export async function onMarkAsCharged(lateBox) {
    const stripe = lateBox.user.stripe;
    // add the stripe fields
    if (!stripe.late_box_subscriptions) {
        stripe.late_box_subscriptions = [];
    }
    try {
        const lateBoxSubscription = { 'box_id': lateBox.id };
        const customerId = stripe.stripe_id;
        if (customerId) {
            const country = localStorage.getItem('country');
            const result = await StripeController.createLateBoxSubscription(customerId, country);
            const subResult = result.data.result;

            lateBoxSubscription.subscription_id = subResult.id;
            lateBoxSubscription.status = subResult.status;
            lateBoxSubscription.created_at = subResult.created;
            lateBoxSubscription.created_from = 'Tidie';
        }

        stripe.late_box_subscriptions.push(lateBoxSubscription);
        lateBox.user.stripe = stripe;
        const payload = { stripe };
        await UserController.addStripeSubscription(lateBox.user.id, payload);
    }
    catch (error) {
        console.error(error);
    }
}


export const YellowButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(yellow[500]),
        backgroundColor: yellow[500],
        '&:hover': {
            backgroundColor: yellow[700],
        },
    },
}))(Button);

export const OrangeButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(amber['A400']),
        backgroundColor: amber['A400'],
        '&:hover': {
            backgroundColor: amber['A700'],
        },
    },
}))(Button);

export const GreenButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(teal['A400']),
        backgroundColor: teal['A400'],
        '&:hover': {
            backgroundColor: teal['A700'],
        },
    },
}))(Button);

export function validate(missingItem, newStatus, callback) {
    return ProductController.getProduct(missingItem.barcode)
        .then((retrievedProduct) => {
            if (retrievedProduct.status === 'kept') {
                return Promise.reject("Item status has been already updated.");
            }

            return ProductController.getProductLogByBoxId(missingItem.barcode, missingItem.currentBox)
        })
        .then((log) => {
            if (Boolean(log.investigated) && newStatus !== 'charged') {
                return Promise.reject("Item is already being investigated.");
            }

            callback(true);
        })
        .catch((error) => {
            console.log(error);
            callback(false, error);
        });
}
